$(document).ready(function () {
    // Clear form data when changing tabs
    $('#resources-add-files .nav-tabs a').bind('click', function (e) {
        var form = $('#resources-add-files form .tab-content');
        form.find('input:text, input:password, input:file, select, textarea').val('');
        form.find('input:radio, input:checkbox')
            .removeAttr('checked').removeAttr('selected');
    });

    $('.event').bind('click', function (e) {
        var calEvent = $(this).data('object');
        showEventDetails(calEvent, null, null);
        e.preventDefault();
    });

    // Add action listener to the event objects
    $('.search-event').bind('click', function (e) {
        var event_id = $(this).data('event-id');
        $.ajax({
            url: base_url + 'timetable/ajax_event/' + event_id,
            success: showEventDetails,
        });
        e.preventDefault();
    });

    $('.remove-filter').bind('click', function () {
        // Get url
        var url = $(this).data('url');

        // Set page action
        window.location.href = url;
    });
});

/**
 * Function to show the details of the event
 *
 * @param calEvent the calendar event with the data
 *
 * @return void
 */
export function showEventDetails(calEvent) {
    // Convert to ints
    calEvent.start = parseInt(calEvent.start);
    calEvent.end = parseInt(calEvent.end);

    // Ensure that resources, tutors, locations and outcomes all default to an empty array
    // This is so that we can use nice, clean, readable code later on...
    calEvent.resources       = calEvent.resources ? _.values(calEvent.resources) : [];
    calEvent.tutors          = calEvent.tutors ? _.values(calEvent.tutors) : [];
    calEvent.locations       = calEvent.locations ? _.values(calEvent.locations) : [];
    calEvent.outcomes.tomdoc = calEvent.outcomes.tomdoc ? _.values(calEvent.outcomes.tomdoc) : [];
    calEvent.outcomes.local  = calEvent.outcomes.local ? _.values(calEvent.outcomes.local) : [];

    // Grab the data for the location & lecturers
    var locations         = '';
    var overflow_location = '';
    var lecturers         = '';
    var tags              = '';

    // Populate the data
    $('#modal-event-title').html(calEvent.title);

    // Locations
    if (calEvent.locations && calEvent.locations.length > 0) {
        $.each(calEvent.locations, function (idx, location) {
            if (location.building !== null && location.room !== null) {
                var location_title = location.room + ', ' + location.building;

                if (calEvent.locations.length > 1 && calEvent.isgroupteaching === '1' && Object.hasOwn(calEvent.attendees, location.forgroup)) {
                    location_title += ' (' + calEvent.attendees[location.forgroup].a_name + ')'; // Include the Group Name
                }

                if (location.postcode) {
                    locations += '<li><a href="http://map.google.co.uk/maps?q=' + location.postcode.replaceAll(' ', '+') + '"><i class="' + FontAwesome.prefix('solid', 'location-dot') + '"></i>' + location_title + '</a></li>';
                } else {
                    locations += '<li><i class="' + FontAwesome.prefix('solid', 'location-dot') + '"></i>' + location.name + '</li>';
                }
            }
        });
    } else {
        locations = '<li><i class="' + FontAwesome.prefix('solid', 'location-dot') + '"></i><em>Location Information Unavailable</em></li>';
    }
    $('#modal-event-location').html('<ul class="padded-list">' + locations + '</ul>');

    $('#modal-event-overflow-location').empty();
    if (calEvent.overflow_id) {
        var overflow_location_title = calEvent.overflow_room + ', ' + calEvent.overflow_building;
        if (calEvent.overflow_postcode) {
            overflow_location += '<li><a href="http://map.google.co.uk/maps?q=' + calEvent.overflow_postcode.replaceAll(' ', '+') + '"><i class="' + FontAwesome.prefix('solid', 'location-arrow') + '"></i>' + overflow_location_title + ' (Overflow Location)</a></li>';
        } else {
            overflow_location += '<li><i class="' + FontAwesome.prefix('solid', 'location-arrow') + '"></i>' + calEvent.overflow_room + ' (Overflow Location)</li>';
        }
        $('#modal-event-overflow-location').html('<ul class="padded-list">' + overflow_location + '</ul>');
    }

    // Tutors
    if (calEvent.tutors && calEvent.tutors.length > 0) {
        // Sort tutors by lead lecturer first
        calEvent.tutors.sort(function (a, b) {
            return b.leadlecturer - a.leadlecturer;
        });

        $.each(calEvent.tutors, function (idx, lecturer) {
            if (lecturer.title !== null && lecturer.firstname !== null && lecturer.lastname !== null) {
                var leadLecturer = lecturer.leadlecturer === '1' ? ' (Lead Lecturer)' : '';
                lecturers += '<li><a href="mailto:' + lecturer.email + '"><i class="' + FontAwesome.prefix('solid', 'mortar-board') + '"></i>' + lecturer.title + ' ' + lecturer.firstname.substring(0, 1) + '. ' + lecturer.lastname + leadLecturer + '</a></li>';
            }
        });
    } else {
        lecturers = '<li><i class="' + FontAwesome.prefix('solid', 'mortar-board') + '"></i><em>Lecturer Information Unavailable</em></li>';
    }
    $('#modal-event-lecturer').html('<ul class="' + (calEvent.tutors.length > 0 ? 'padded-links' : 'padded-list') + '">' + lecturers + '</ul>');

    // Check if we span days
    const eventStart = dayjs.unix(calEvent.start).tz('Europe/London');
    const eventEnd   = dayjs.unix(calEvent.end).tz('Europe/London');
    const clockIcon  = '<i class="' + FontAwesome.prefix('regular', 'clock') + '"></i>';
    let timeHTML     = '';

    if (calEvent.end - calEvent.start < 86400) {
        timeHTML = clockIcon + eventStart.format(TIME) + ' - ' + eventEnd.format(TIME) + '  ' + eventStart.format('dddd ' + LONGDATE);
    } else {
        timeHTML = clockIcon + eventStart.format(TIME + ' ' + LONGDATE) + ' - ' + eventEnd.format(TIME + ' ' + LONGDATE);
    }

    $('#modal-event-times').html('<ul class="padded-list"><li>' + timeHTML + '</li></ul>');

    // Categories/Tags
    if (calEvent.tags) {
        $.each(calEvent.tags, function (idx, tag) {
            tags += '<li><a href="timetable/categories/' + tag.tagid + '"><i class="' + FontAwesome.prefix('solid', 'tags') + '"></i>' + tag.tagname + '</li>';
        });
        $('#modal-event-tag').html('<ul class="padded-list"><li class="heading">Categories</li>' + tags + '</ul>');
    }

    // Description
    $('#event-description').html('<ul class="padded-list"><li class="heading">Description</li><li>' + (calEvent.description ? calEvent.description : '<em>No description available</em>') + '</li></ul>');

    // Equipment
    $('#event-equipment').html(calEvent.equipment ? '<ul class="padded-list"><li class="heading">Equipment</li><li>' + calEvent.equipment + '</li></ul>' : '');

    var localoutcomes = '';
    var tomdocoutcomes = '';

    // Learning Outcomes
    if (calEvent.outcomes.local.length > 0) {
        $.each(calEvent.outcomes.local, function (idx, outcome) {
            localoutcomes += '<li>' + outcome + '</li>';
        });

        var html = '<ul class="padded-list"><li class="heading">University of Aberdeen</li>' + localoutcomes + '</ul>';

        // Add tomorrow docs if we have any
        if (calEvent.outcomes.tomdoc.length > 0) {
            $.each(calEvent.outcomes.tomdoc, function (idx, outcome) {
                tomdocoutcomes += '<li>' + outcome + '</li>';
            });
            html += '<ul class="padded-list"><li class="heading">Tomorrow\'s Doctors</li>' + tomdocoutcomes + '</ul>';
        }

        $('#tabs-outcomes').html(html);
    } else {
        $('#tabs-outcomes').html('<ul class="padded-list"><li><em>Please refer to your course handbook/workbook for learning outcomes.</em></ul></li>');
    }

    // Learning Resources
    var resources = '';
    var btnicon;
    var btntext;
    var iconext;
    if (calEvent.resources.length > 0) {
        // We have learning resources
        calEvent.resources.sort(function (a, b) {
            return a.position - b.position;
        });

        $.each(calEvent.resources, function (idx, resource) {
            if (resource.type === 'file') {
                btnicon = FontAwesome.prefix('solid', 'download');
                btntext = 'Download ' + File.getReadableExtension(resource.extension.replace('.', '')) + ' <span class="small text-dark">(' + File.getReadableFileSizeString(resource.size, 2) + ')</span>';
                iconext = File.getIcon(resource.extension);
            } else if (resource.type === 'link') {
                btnicon = FontAwesome.prefix('solid', 'link');
                btntext = 'Go to ' + resource.name;
                iconext = FontAwesome.prefix('solid', 'link');
            } else if (resource.type === 'recording') {
                btnicon = FontAwesome.prefix('solid', 'video-camera');
                btntext = 'Go to ' + resource.name;
                iconext = FontAwesome.prefix('solid', 'video-camera');
            }

            resources += '<li class="' + ($('.has-basic-role').length ? '' : 'sortable-position') + '" data-event-resource="' + resource.evresourceid + '" data-position="' + resource.position + '">';
            resources +=    '<p>';
            resources +=        '<strong><i class="' + iconext + '"></i>' + resource.name + '</strong><br>';
            // Display the filename and uses Array.prototype.split and Array.prototype.join() to remove the file hash
            resources +=        '<em class="small text-dark">' + resource.uri.split('_').slice(1).join('_') + '<br>';
            resources +=        '<br>';
            resources +=        'Uploaded: ' + dayjs.unix(resource.lastmodifieddate).format(LONGDATE) + ' by ' + resource.firstname + ' ' + resource.lastname + '</em>';
            resources +=    '</p>';
            if (resource.description) {
                resources +=    '<p><em>' + resource.description + '</em></p>';
            }
            resources +=    '<p><a href="' + base_url + 'pages/resource/' + resource.id + '" class="btn btn-sm btn-default" role="button"><i class="' + btnicon + '"></i>' + btntext + '</a></p>';
            resources += '</li>';
        });
    } else {
        resources = '<li><em>' + calEvent.resourceavailability + '</em></li>';
    }

    $('#tabs-resources').html('<div><ul class="padded-list" id="sortable">' + resources + '</ul></div>');

    if ($('.has-basic-role').length === 0) {
        $('#sortable').sortable({
            containment: 'parent',
            scroll: true,
            update: function (event, ui) {
                $(this).children().each(function (index) {
                    // Strict comparison cannot be used in the check below
                    if ($(this).attr('data-position') != index + 1) {
                        $(this).attr('data-position', index + 1).addClass('updated');
                    }
                });

                saveNewPositions();
            },
        });
    }

    // Add the button actions
    $('#btnStaffActionResources').attr('href', base_url + 'resources/manager/' + calEvent.id);
    $('#btnStaffActionOutcomes').attr('href', base_url + 'outcomes/manager/' + calEvent.id);
    $('#btnStaffActionComms').attr('href', base_url + 'timetable/staffaction/comms/' + calEvent.id);
    $('#btnStaffActionRegister').attr('href', base_url + 'registers/classlist/' + calEvent.id);
    $('#btnStaffActionCombinedRegister').attr('href', base_url + 'registers/classlist/' + calEvent.id + '/true');
    $('#btnStaffActionPhotoboard').attr('href', base_url + 'registers/photoboard/' + calEvent.id);

    // Initialise the ratings picker for this event
    initialiseRatings(calEvent, '#modal-event-ratings');

    // Show the modal
    $('#eventdetails').modal('show');
}

/**
 * Function for ajax call to update event resource positions
 *
 * @return void
 */
function saveNewPositions() {
    var positions = [];
    $('.updated').each(function () {
        positions.push([$(this).attr('data-event-resource'), $(this).attr('data-position')]);
        $(this).removeClass('updated');
    });

    $.ajax({
        url: base_url + 'timetable/ajax_positions',
        type: 'get',
        dataType: 'json',
        data: {
            postionsData: positions,
        },
    });
}

var calEvent;
var ratingsIcons;
var requestedRating;
var commentTextarea;

/**
 * Set the global variable values, which are initialised in \myvle\src\application\views\timetable\index.php. This then
 * also sets the initial state for the ratings icons and adds the mouse over listener for the icons, the mouse out
 * listener for the icons parent element (resetting it to the currently saved rating) and finally the click listener
 * which will do an ajax call to save the rating against this user/event
 *
 * @param {object} iniCalEvent The event data used when the modal is opened
 * @param {string} elementId   The element identifier containing the rating icons
 *
 * @returns void
 */
function initialiseRatings(iniCalEvent, elementId) {
    // Only initialise if the element containing the rating icons exists
    if ($(elementId).length) {
        // Get relevant elements
        var ratingsContainer = $(elementId);
        ratingsIcons         = ratingsContainer.find('i.rating');
        commentTextarea      = ratingsContainer.find('textarea#modal-event-comments-text');

        // Initialise the event data
        calEvent = iniCalEvent;

        // If the user event rating is not a natural number then set to 0
        if (isNaN(calEvent.usereventrating) || calEvent.usereventrating < 0) {
            calEvent.usereventrating = 0;
        }

        // Initialise using the value from the database (or the value changed within this session)
        requestedRating  = calEvent.usereventrating;

        // Set the initial ratings value
        forAllIcons(calEvent.usereventrating, ratingOn, ratingOff);

        // Set the initial comments value
        commentTextarea.val(calEvent.usereventcomment);

        // When mouse hovers over the rating, set the icons up to that rating as on
        ratingsIcons.on('mouseenter', mouseOverRating);

        // When mouse leaves the rating container element, reset the icons to the saved value
        ratingsContainer.on('mouseleave', mouseOutRating);

        // When mouse clicks on a rating, set the icons up to that rating as on
        ratingsIcons.on('click', mouseClickRating);

        // When mouse clicks on the comments submit button, save comment and close comment box
        $('#modal-event-comments-form').on('submit', submitComment);

        // When mouse leaves the rating container element, reset the icons to the saved value
        $('#modal-event-comments-cancel').on('click', hideCommentForm);

        // When the comments box collapses, reinstate the submit button
        $('#modal-event-comments').on('hidden.bs.collapse', submitButtonReset);
    }
}

/**
 * Runs a function on all rating elements when mouse enters any individual rating element, ensuring the appropriate
 * elements are highlighted and others are not.
 *
 * @returns void
 */
function mouseOverRating() {
    // Highlight the appropriate number of stars on mouse over
    forAllIcons($(this).data('rating'), ratingOn, ratingOff);
};

/**
 * Runs a function on all rating elements when mouse leaves the parent element, ensuring that the highlighted rating
 * elements are defaulted back to the currently saved rating (or zero if nothing is set).
 *
 * @returns void
 */
function mouseOutRating() {
    // Highlight the appropriate number of stars on mouse out
    forAllIcons(requestedRating, ratingOn, ratingOff);
}

/**
 * Runs a function on all rating elements when mouse clicks on the element. It then saves the clicked value to
 * database.
 *
 * @returns void
 */
function mouseClickRating() {
    // Get the selected rating value and store it for use as the mouse out default
    requestedRating = $(this).data('rating');

    // Set the icons to the clicked rating - this will be reset if Ajax post fails
    forAllIcons(requestedRating, ratingOn, ratingOff);

    // Do ajax call to set the rating for this users event
    setUsersRating(requestedRating);

    // Open the comments input
    $('#modal-event-comments').collapse('show');
}

/**
 * Runs one of the two callback functions on all rating elements. If the rating element currently being processed is
 * less than or equal to the given selected rating then it is highlighted using the given highlight callback.
 * Otherwise the obscure callback is run on the element.
 *
 * @callback highlightCallback
 * @callback obscureCallback
 *
 * @param {int}      selectedRating    The rating that we want to display
 * @param {callback} highlightCallback The callback function to run when highlighting a rating element
 * @param {callback} obscureCallback   The callback function to run when obscuring a rating element
 *
 * @returns void
 */
function forAllIcons(selectedRating, highlightCallback, obscureCallback) {
    // Initialise a variable to store the currently selected rating
    var rating;

    // Iterate through each rating element
    ratingsIcons.each(function () {
        // Get the value for the currently selected rating
        rating = $(this).data('rating');

        // If the selected rating
        if (selectedRating >= rating) {
            highlightCallback($(this));
        } else {
            obscureCallback($(this));
        }
    });
}

/**
 * Runs a function on all rating elements when mouse leaves the parent element, ensuring that the highlighted rating
 * elements are defaulted back to the currently saved rating (or zero if nothing is set).
 *
 * @param {event} e The event that has been fired
 *
 * @returns void
 */
function submitComment(e) {
    // Add progress indicator classes
    submitButtonLoader();

    // Get the selected rating value and store it for use as the mouse out default
    var requestedComment = commentTextarea.val();

    // Do ajax call to set the rating & comment for this users event
    setUsersComment(requestedComment, commentSaved);

    // Prevent the http submission of the form
    e.preventDefault();
}

/**
 * Passes a given rating value to an ajax call which saves the rating to database.
 *
 * @param {int} ratingVal The rating that we want to save to the database
 *
 * @returns void
 */
function setUsersRating(ratingVal) {
    // Set the data to sent to the AJAX request
    var ratingsAjaxData = {};
    ratingsAjaxData.eventId = calEvent.id;
    ratingsAjaxData.rating  = ratingVal;

    // Process the form
    $.ajax({
        type: 'POST',
        url: setRatingsUrl,
        data: ratingsAjaxData,
        dataType: 'json',
    })
        .done(function (data) {
            if (data.successcode === 1) {
            // Submission successful - ensure requestedRating value & saved value for event are set
                requestedRating           = data.rating;
                calEvent.usereventrating  = data.rating;

                // Display the saved message
                ratingSaved();
            } else {
            // Change the requestedRating value back to the saved value for this event
                requestedRating = calEvent.usereventrating;

                // Change the highlighted icons back to the saved value
                forAllIcons(calEvent.usereventrating, ratingOn, ratingOff);

                // Display error
                alert('An error has occurred and no change has been made to your rating.');

                showErrorStatus();
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
        // Change the requestedRating value back to the saved value for this event
            requestedRating = calEvent.usereventrating;

            // Change the highlighted icons back to the saved value
            forAllIcons(calEvent.usereventrating, ratingOn, ratingOff);

            // Display error
            alert('An unknown error has occurred and no change has been made to your rating.');

            showErrorStatus();
        });
}

/**
 * Passes a given rating value to an ajax call which saves the rating to database.
 *
 * @param {string} commentVal The comment that we want to save to the database
 *
 * @returns void
 */
function setUsersComment(commentVal) {
    // Set the data to sent to the AJAX request
    var commentsAjaxData = {};
    commentsAjaxData.eventId = calEvent.id;
    commentsAjaxData.comment = commentVal;

    // Process the form
    $.ajax({
        type: 'POST',
        url: setCommentsUrl,
        data: commentsAjaxData,
        dataType: 'json',
    })
        .done(function (data) {
            if (data.successcode === 1) {
            // Submission successful - ensure requestedRating value & saved value for event are set
                var requestedComment      = data.comment;
                calEvent.usereventcomment = data.comment;

                // Display the saved message
                commentSaved();
            } else {
            // Display error
                alert('An error has occurred and no change has been made to your comment.');

                showErrorStatus();
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
        // Display error
            alert('An unknown error has occurred and no change has been made to your comment.');

            showErrorStatus();
        });
}

/**
 * Switches on a given rating element
 *
 * @param {object} element The element that we want to switch on
 *
 * @returns void
 */
function ratingOn(element) {
    element.removeClass(FontAwesome.prefix('regular', 'star'));
    element.addClass(FontAwesome.prefix('solid', 'star'));
}

/**
 * Switches off a given rating element
 *
 * @param {object} element The element that we want to switch off
 *
 * @returns void
 */
function ratingOff(element) {
    element.removeClass(FontAwesome.prefix('solid', 'star'));
    element.addClass(FontAwesome.prefix('regular', 'star'));
}

/**
 * Show the saved notification
 *
 * @returns void
 */
function ratingSaved() {
    showSavedStatus('Rating Saved');
}

/**
 * Mark as saved and close comments box
 *
 * @returns void
 */
function commentSaved() {
    // Close comments box
    hideCommentForm();

    // Mark as saved
    showSavedStatus('Comment Saved');
}

/**
 * Collapses the comment form
 *
 * @returns void
 */
function hideCommentForm() {
    // Mark as saved and close comments box
    $('#modal-event-comments').collapse('hide');
}

/**
 * Show an error message in the save status container
 *
 * @returns void
 */
function showErrorStatus() {
    $('#modal-event-save-message').removeClass('label-success').addClass('label-danger');
    $('#modal-event-save-message').html('<i class="' + FontAwesome.prefix('solid', 'exclamation') + '"></i> Error. Please try again.');
    showStatusMessage();
    submitButtonReset();
}

/**
 * Show a given message in the save status container
 *
 * @param {string} savedMessage The message to display in the saved notification
 *
 * @returns void
 */
function showSavedStatus(savedMessage) {
    $('#modal-event-save-message').removeClass('label-danger').addClass('label-success');
    $('#modal-event-save-message').html('<i class="' + FontAwesome.prefix('solid', 'check') + '"></i> ' + savedMessage);
    showStatusMessage();
}

/**
 * Cancel any other fades on this element then fade in the status element for a period of time
 *
 * @returns void
 */
function showStatusMessage() {
    $('#modal-event-save-message').clearQueue().stop().fadeIn('slow').delay(2000).fadeOut('slow');
}

/**
 * Displays the spinner and please wait text and disables the button
 *
 * @returns void
 */
function submitButtonLoader() {
    // Re-enable the submit button
    $('#modal-event-comments-submit').prop('disabled', true);

    // Re-instate the original button text
    $('#modal-event-comments-submit').html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + ' fa-pulse fa-fw"></i> Please Wait...');
}

/**
 * Displays the standard submit button text and re-enables the button
 *
 * @returns void
 */
function submitButtonReset() {
    // Re-enable the submit button
    $('#modal-event-comments-submit').prop('disabled', false);

    // Re-instate the original button text
    $('#modal-event-comments-submit').html('<i class="' + FontAwesome.prefix('solid', 'save') + '"></i> Save comment');
}
